import { createAsyncThunk } from '@reduxjs/toolkit'
import { SignalRService } from 'features/SignalR/service/SignalRService'
import { debounce } from 'lodash'

export const subscribeToUpdates = createAsyncThunk<any, any, { state: any }>(
  'live-updates/subscribeToUpdates',
  async ({
    groupName,
    clientMethodName,
    clientMethod,
  }: {
    groupName: string
    clientMethodName: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    clientMethod: (...args: any[]) => void
  }) => {
    const hub = await SignalRService.GetHub()

    hub.unregister(clientMethodName)

    hub.registerHandler(
      clientMethodName,
      debounce(clientMethod, 1000, {
        leading: true,
        trailing: true,
        maxWait: 1000,
      })
    )

    await hub.JoinGroup(
      groupName,
      () => {
        console.info('joined group', groupName)
      },
      true
    )
  }
)

export const unsubscribeFromUpdates = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'live-updates/unsubscribeFromUpdates',
  async ({
    groupName,
    clientMethodName,
  }: {
    groupName: string
    clientMethodName: string
  }) => {
    const hub = await SignalRService.GetHub()

    hub.unregister(clientMethodName)

    return await hub.LeaveGroup(groupName, () =>
      console.info('leftGroup', groupName)
    )
  }
)
